import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { PackagesContactInfo } from "./component";
import { IStoreState } from "../../../../reducers/types";
import { getFlightTripIdentity } from "../../../flight-shop/utils/useFlightTripIdentity";

const mapStateToProps = (state: IStoreState) => {
  const { tripDetails } = getFlightTripIdentity(state);
  return {
    tripDetails,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PackagesContactInfoConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPackagesContactInfo = withRouter(
  connector(PackagesContactInfo)
);
